import { useContext } from 'react';
import { useCartPricing } from '../contexts/CartPricingContext';
import CheckoutContext from '../lib/CheckoutContext';
import getCouponCookie from '../lib/getCouponCookie';
import { CouponCookieData, isAdoptionPromoApplied } from '../lib/util';
import { showRescueGwaVariant } from '../views/RescueLanding/RescueBanner';

/**
 * Whether the adoption discount is on the cart and survived pricing, as opposed to merely intended.
 *
 * The rescue cookie says the shopper is an adopter, not that they got the gift: auto-apply can fail
 * and leave the cart at list price. Every surface that credits the adoption - the promo field it
 * closes, the membership note claiming the shelter covered it - has to read the second thing, or the
 * page tells an adopter their membership is free while charging them for it.
 */
export default function useAdoptionPromoApplied(): boolean {
  const cartPricing = useCartPricing();
  const { cart } = useContext(CheckoutContext);
  const couponCookie: CouponCookieData | undefined = getCouponCookie();

  return isAdoptionPromoApplied({
    variantEnabled: showRescueGwaVariant(),
    couponCode: cart.couponCode,
    hasCouponValidationError: !!cartPricing.validationErrors?.couponCode,
    adopterAlias: couponCookie?.code,
  });
}
